import { resolveErrorMessage } from 'modules/errors';
import { suggestAudition } from './api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const sendSuggestion = createAsyncThunk(
  'auditionSuggestions/suggestAudition',
  async ({ auditionId, talentId, message }) =>
    await suggestAudition(auditionId, talentId, message),
);

const auditionSuggestionsSlice = createSlice({
  name: 'auditionSuggestions',
  initialState: {
    error: false,
    loading: false,
  },
  extraReducers: builder => {
    builder
      .addCase(sendSuggestion.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(sendSuggestion.fulfilled, (state, _) => {
        state.loading = false;
        state.error = false;
      })
      .addCase(sendSuggestion.rejected, (state, action) => {
        state.error = resolveErrorMessage(action.error);
      });
  },
  selectors: {
    getSuggestionError: state => state.error,
  },
});

export const reducer = auditionSuggestionsSlice.reducer;
export const { getSuggestionError } = auditionSuggestionsSlice.selectors;
